/* DGLYF theme — minimal, dependency-free, deferred.
   Handles: mobile nav, mega menu keyboard support, search panel,
   cart drawer, quick add, variant picker, gallery, collection sort. */

(function () {
  'use strict';

  var money = function (cents) {
    var format = window.DGLYF && window.DGLYF.moneyFormat;
    var value = (cents / 100).toFixed(2);
    if (format && format.indexOf('{{') !== -1) {
      return format.replace(/\{\{\s*amount\s*\}\}/, value).replace(/\{\{[^}]*\}\}/, value);
    }
    return value;
  };

  /* ---------- Overlay panels (cart drawer, search, mobile nav) ---------- */
  var lastFocused = null;

  function openPanel(panel) {
    if (!panel) return;
    lastFocused = document.activeElement;
    panel.removeAttribute('hidden');
    requestAnimationFrame(function () { panel.classList.add('is-open'); });
    document.documentElement.classList.add('no-scroll');
    var focusable = panel.querySelector('[data-panel-close], input, button, a[href]');
    if (focusable) focusable.focus();
  }

  function closePanel(panel) {
    if (!panel) return;
    panel.classList.remove('is-open');
    document.documentElement.classList.remove('no-scroll');
    window.setTimeout(function () { panel.setAttribute('hidden', ''); }, 200);
    if (lastFocused && lastFocused.focus) lastFocused.focus();
  }

  document.addEventListener('click', function (event) {
    var opener = event.target.closest('[data-panel-open]');
    if (opener) {
      event.preventDefault();
      openPanel(document.getElementById(opener.getAttribute('data-panel-open')));
      return;
    }
    var closer = event.target.closest('[data-panel-close]');
    if (closer) {
      event.preventDefault();
      closePanel(closer.closest('[data-panel]'));
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    var open = document.querySelector('[data-panel].is-open');
    if (open) closePanel(open);
    var openMenu = document.querySelector('.mega.is-open');
    if (openMenu) openMenu.classList.remove('is-open');
  });

  /* Focus trap inside open panels */
  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Tab') return;
    var panel = document.querySelector('[data-panel].is-open');
    if (!panel) return;
    var items = panel.querySelectorAll('a[href], button:not([disabled]), input, select, textarea');
    if (!items.length) return;
    var first = items[0];
    var last = items[items.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });

  /* ---------- Mobile nav ---------- */
  var navToggle = document.querySelector('[data-nav-toggle]');
  var mobileNav = document.querySelector('[data-mobile-nav]');
  if (navToggle && mobileNav) {
    navToggle.addEventListener('click', function () {
      var open = mobileNav.classList.toggle('is-open');
      navToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  /* ---------- Mega menu: pointer + keyboard ---------- */
  document.querySelectorAll('[data-mega]').forEach(function (item) {
    var trigger = item.querySelector('[data-mega-trigger]');
    if (!trigger) return;

    function setOpen(state) {
      item.classList.toggle('is-open', state);
      trigger.setAttribute('aria-expanded', state ? 'true' : 'false');
    }

    trigger.addEventListener('click', function (event) {
      if (window.matchMedia('(min-width: 900px)').matches && trigger.tagName === 'BUTTON') {
        event.preventDefault();
        setOpen(!item.classList.contains('is-open'));
      }
    });
    item.addEventListener('mouseenter', function () { setOpen(true); });
    item.addEventListener('mouseleave', function () { setOpen(false); });
    item.addEventListener('focusout', function (event) {
      if (!item.contains(event.relatedTarget)) setOpen(false);
    });
  });

  /* ---------- Sticky header shadow ---------- */
  var header = document.querySelector('[data-header]');
  if (header) {
    var onScroll = function () {
      header.classList.toggle('is-stuck', window.scrollY > 8);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---------- Product gallery ---------- */
  document.querySelectorAll('[data-gallery]').forEach(function (gallery) {
    var main = gallery.querySelector('[data-gallery-main]');
    gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (!main) return;
        main.src = btn.getAttribute('data-src');
        main.srcset = '';
        main.alt = btn.getAttribute('data-alt') || '';
        gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (b) {
          b.setAttribute('aria-current', b === btn ? 'true' : 'false');
        });
      });
    });
  });

  /* ---------- Variant picker ---------- */
  document.querySelectorAll('[data-product-form]').forEach(function (form) {
    var select = form.querySelector('[data-variant-select]');
    if (!select) return;
    select.addEventListener('change', function () {
      var option = select.options[select.selectedIndex];
      var available = option.getAttribute('data-available') === 'true';
      document.querySelectorAll('[data-variant-price]').forEach(function (el) {
        el.textContent = option.getAttribute('data-price') || el.textContent;
      });
      document.querySelectorAll('[data-variant-id]').forEach(function (input) {
        input.value = option.value;
      });
      form.querySelectorAll('[data-add-to-cart]').forEach(function (submit) {
        submit.disabled = !available;
        submit.textContent = available ? submit.getAttribute('data-label') : submit.getAttribute('data-sold-out') || 'Sold out';
      });
    });
  });

  /* ---------- Cart drawer ---------- */
  var drawer = document.getElementById('cart-drawer');

  function renderCart(cart) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = cart.item_count;
      el.hidden = cart.item_count === 0;
    });
    if (!drawer) return;
    var body = drawer.querySelector('[data-cart-items]');
    var footer = drawer.querySelector('[data-cart-footer]');
    var empty = drawer.querySelector('[data-cart-empty]');
    if (!body) return;

    if (!cart.items.length) {
      body.innerHTML = '';
      if (empty) empty.hidden = false;
      if (footer) footer.hidden = true;
      return;
    }
    if (empty) empty.hidden = true;
    if (footer) footer.hidden = false;

    body.innerHTML = cart.items.map(function (item, index) {
      var img = item.image
        ? '<img src="' + item.image.replace(/(\.[a-z]+)(\?|$)/, '_160x$1$2') + '" alt="" width="76" height="76" loading="lazy">'
        : '';
      return (
        '<li class="cart-item">' +
        '<div class="cart-item__img">' + img + '</div>' +
        '<div class="cart-item__info">' +
        '<a class="cart-item__title" href="' + item.url + '">' + item.product_title + '</a>' +
        (item.variant_title ? '<p class="xsmall muted">' + item.variant_title + '</p>' : '') +
        '<p class="small"><strong>' + money(item.final_line_price) + '</strong></p>' +
        '<div class="cart-item__actions">' +
        '<div class="qty">' +
        '<button type="button" class="qty__btn" data-cart-qty="' + (index + 1) + '" data-qty="' + (item.quantity - 1) + '" aria-label="Decrease quantity">&minus;</button>' +
        '<span aria-live="polite">' + item.quantity + '</span>' +
        '<button type="button" class="qty__btn" data-cart-qty="' + (index + 1) + '" data-qty="' + (item.quantity + 1) + '" aria-label="Increase quantity">+</button>' +
        '</div>' +
        '<button type="button" class="link-btn xsmall" data-cart-qty="' + (index + 1) + '" data-qty="0">Remove</button>' +
        '</div></div></li>'
      );
    }).join('');

    var total = drawer.querySelector('[data-cart-total]');
    if (total) total.textContent = money(cart.total_price);
  }

  function fetchCart(open) {
    return fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart.js' : '/cart.js', {
      headers: { Accept: 'application/json' }
    })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        renderCart(cart);
        if (open) openPanel(drawer);
        return cart;
      });
  }

  if (drawer) {
    drawer.addEventListener('click', function (event) {
      var btn = event.target.closest('[data-cart-qty]');
      if (!btn) return;
      btn.disabled = true;
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: Number(btn.getAttribute('data-cart-qty')), quantity: Number(btn.getAttribute('data-qty')) })
      })
        .then(function (res) { return res.json(); })
        .then(renderCart)
        .catch(function () { window.location.href = '/cart'; });
    });
  }

  /* ---------- Add to cart (drawer-aware, inline errors) ---------- */
  document.addEventListener('submit', function (event) {
    var form = event.target.closest('[data-ajax-cart]');
    if (!form) return;
    event.preventDefault();

    var alertEl = form.querySelector('[data-form-alert]');
    var button = form.querySelector('[type="submit"]');
    var original = button ? button.textContent : '';
    if (alertEl) alertEl.hidden = true;
    if (button) {
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      button.textContent = 'Adding…';
    }

    fetch('/cart/add.js', { method: 'POST', body: new FormData(form), headers: { Accept: 'application/json' } })
      .then(function (res) {
        return res.json().then(function (body) {
          if (!res.ok) throw new Error(body.description || body.message || 'We could not add this item. Please try again.');
          return body;
        });
      })
      .then(function () {
        if (form.getAttribute('data-redirect') === 'checkout') {
          window.location.href = '/checkout';
          return;
        }
        return fetchCart(true);
      })
      .catch(function (error) {
        if (alertEl) {
          alertEl.hidden = false;
          alertEl.textContent = error.message;
        } else {
          window.alert(error.message);
        }
      })
      .then(function () {
        if (button) {
          button.disabled = false;
          button.removeAttribute('aria-busy');
          button.textContent = original;
        }
      });
  });

  /* ---------- Collection sort / filters ---------- */
  var sortSelect = document.querySelector('[data-sort]');
  if (sortSelect) {
    sortSelect.addEventListener('change', function () {
      if (sortSelect.form) sortSelect.form.submit();
    });
  }
  document.querySelectorAll('[data-filter-form] input').forEach(function (input) {
    input.addEventListener('change', function () {
      input.form.submit();
    });
  });
})();
